import React, { useEffect, useState } from "react";
import axios from "axios";
import Breadcrumb from "../../../../Components/Breadcrumb/Breadcrumb";
import EvnVar from "../../../../EnvVar";
import Cookies from "js-cookie";

const EventProgram = () => {
  const baseURL = EvnVar();
  const token = Cookies.get("jwt");
  const [eventsData, setEventsData] = useState([]);

  useEffect(() => {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${baseURL}/user/eventProgram`,
      headers: {
        Authorization: token,
      },
      withCredentials: true,
    };

    axios
      .request(config)
      .then((response) => {
        setEventsData(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);
  return (
    <>
      <Breadcrumb data="Event Program" />
      <div className="content-body">
        <div className="table-data">
          <div className="table-responsive">
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Name</th>
                  <th>Status</th>
                  <th>Created At</th>
                  <th>Updated At</th>
                </tr>
              </thead>
              <tbody>
                {eventsData &&
                  eventsData.map((eventData) => (
                    <tr key={eventData.id}>
                      <td>{eventData.id}</td>
                      <td>{eventData.name}</td>
                      <td>{eventData.status}</td>
                      <td>{eventData.created_at}</td>
                      <td>{eventData.updated_at}</td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

export default EventProgram;
